<template>
  <b-container fluid id="main">
    <div class="add-client-button">
      <add-client-button/>
    </div>
    <b-row>
      <b-col>
        <b-table striped hover
                 :sort-by="loadSortBy()"
                 :sort-desc="loadSortDesc()"
                 :sort-null-last="!localStore.sortIsDesc"
                 @sort-changed="saveSort"
                 :busy="storeState.clients === null"
                 :items="storeState.clients === null ? []:Object.values(storeState.clients)"
                 :fields="fields">
          <template v-slot:cell(id)="client">
            <delete-client-button v-bind:client="client.item"/>
          </template>
          <template v-slot:cell(name)="client">
            <b-link @click="() => {routerPush('/client/' + client.item.id)}">{{ client.item.name }}</b-link>
          </template>
          <template v-slot:head(apiKeyCount)>
            <span id="tt_target_api"># API keys <span style="font-size: 80%; font-weight: normal">(Message/Online/Assigned/Total)</span></span>
            <b-tooltip target="tt_target_api" triggers="hover" custom-class="widett" placement="bottom" variant="info">
              <p><b>Total:</b> total number of API keys for this client</p>
              <p><b>Assigned:</b> number of API keys that are actually associated to an identity (the link was used)</p>
              <p><b>Online:</b> users with such an API key that connected to the server in the last 7 days</p>
              <p><b>Message:</b> users who received an application message in the last 7 days (and downloaded it)</p>
            </b-tooltip>
          </template>
          <template v-slot:head(keycloaks)>
            <span id="tt_target_key"># Keycloak users <span style="font-size: 80%; font-weight: normal">(Message/Online/Total)</span></span>
            <b-tooltip target="tt_target_key" triggers="hover" custom-class="widett" placement="bottom" variant="info">
              <p><b>Total:</b> number of users who uploaded their identity to Keycloak and received an API key</p>
              <p><b>Online:</b> users with such an API key that connected to the server in the last 7 days</p>
              <p><b>Message:</b> users who received an application message in the last 7 days (and downloaded it)</p>
            </b-tooltip>
          </template>
          <template v-slot:cell(keycloaks)="client">
            <div class="keycloaks">
              <div v-for="keycloak in Object.values(client.item.keycloaks)" :key="keycloak.id">
                <em>{{keycloak.name}}</em>: {{ keycloak.apiKeyMessageCount }}/{{ keycloak.apiKeyOnlineCount }}/{{ keycloak.apiKeyCount }}
              </div>
            </div>
          </template>
          <template v-slot:cell(versions)="client">
            <div class="keycloaks">
              <div v-for="keycloak in Object.values(client.item.keycloaks)" :key="keycloak.id">
                <a class="invis" href="https://olvid.io/keycloak/changelog/" target="_blank">{{ (keycloak.keycloakVersion && keycloak.pluginVersion) ? keycloak.keycloakVersion + " - v" + keycloak.pluginVersion : "-" }}</a>
              </div>
            </div>
          </template>
          <template v-slot:cell(licenses)="client">
            <div class="keycloaks">
              <div v-for="keycloak in Object.values(client.item.keycloaks)" :key="keycloak.id" :class="(keycloak.licenseCount && keycloak.licenseCount < keycloak.apiKeyCount) ? 'exceeding' : ''">
                {{ (keycloak.licenseCount) ? keycloak.licenseCount : "-" }}
              </div>
            </div>
          </template>
          <template v-slot:cell(lastConnexions)="client">
            <div class="keycloaks">
              <div v-for="keycloak in Object.values(client.item.keycloaks)" :key="keycloak.id">
                {{ (keycloak.lastConnexionTimestamp) ? formatTimestamp(keycloak.lastConnexionTimestamp) : "-" }}
              </div>
            </div>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-danger">
              <b-spinner class="align-middle"></b-spinner>
              <strong> Loading...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {formatDate, store} from "@/main";

import AddClientButton from "@/components/buttons/AddClientButton.vue";
import DeleteClientButton from "@/components/buttons/DeleteClientButton.vue";

const localStore = {
  sortIsDesc: false,
}

export default {
  name: "ClientList",
  components: {AddClientButton, DeleteClientButton},
  data() {
    return {
      storeState: store.state,
      localStore: localStore,
      fields: [
        {
          key: 'id',
          label: '',
          thStyle: {width: '49px'},
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'apiKeyCount',
          sortable: true,
          sortDirection: "desc",
          formatter: (apiKeyCount, key, client) => {
            return client.apiKeyMessageCount + '/' + client.apiKeyOnlineCount + '/' + client.apiKeyAssignedCount + '/' + apiKeyCount
          }
        },
        {
          key: 'keycloaks',
          sortable: true,
          sortDirection: "desc",
          sortByFormatted: true,
          formatter: (keycloaks) => {
            if (Object.values(keycloaks).length !== 0) {
              let total = 0
              Object.values(keycloaks).forEach(keycloak => {
                total += keycloak.apiKeyCount
              })
              return total
            }
            return null
          }
        },
        {
          key: 'versions',
          label: 'Versions',
          sortable: false,
        },
        {
          key: 'licenses',
          label: 'Licenses',
          sortable: false,
        },
        {
          key: 'lastConnexions',
          label: 'Last Connection',
          sortable: false,
        }
        // {
        //   key: 'creationTimestamp',
        //   label: 'Creation date',
        //   sortable: true,
        //   formatter: timestamp => {
        //     return formatDate(new Date(timestamp))
        //   }
        // }
      ],
    }
  },
  methods: {
    routerPush: function (path) {
      this.$router.push(path)
    },
    saveSort: function (ctx) {
      this.localStore.sortIsDesc = ctx.sortDesc
      localStorage.setItem("clientsSort", ctx.sortBy + ',' + ctx.sortDesc)
    },
    loadSortBy: function() {
      const sort = localStorage.getItem("clientsSort")
      if (sort && sort.includes(',')) {
        return sort.split(',')[0]
      }
      return 'name'
    },
    loadSortDesc: function() {
      const sort = localStorage.getItem("clientsSort")
      if (sort && sort.includes(',')) {
        this.localStore.sortIsDesc = sort.split(',')[1] === 'true'
      } else {
        this.localStore.sortIsDesc = false
      }
      return this.localStore.sortIsDesc
    },
    formatTimestamp: function(timestamp) {
      return formatDate(new Date(timestamp))
    }
    // splitVersion: function(v) {
    //   try {
    //     const parts = v.split(".")
    //     if (parts.length === 3) {
    //       return parts[0]*10000 + parts[1]*100 + parts[2]
    //     }
    //   } catch (e) { /* empty */ }
    //   return 0
    // }
  },
}
</script>

<style scoped>
#main {
  padding-top: 15px;
  padding-bottom: 15px;
}
.add-client-button {
  text-align: right;
  margin-bottom: 15px;
}
.invis {
  color: inherit;
}
.keycloaks {
  display: flex;
  min-height: 48px;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: stretch;
  margin-top: -12px;
  margin-bottom: -12px;
}
.exceeding {
  font-weight: bold;
  color: #dc3545;
}
</style>